import { useQuery, UseQueryResult } from "react-query";
import { 
  getActivitiesStats, 
  DashboardFilters, 
  DashboardStatsResponse 
} from "../../services/api/dashboard/dashboardApi";

const dashboardApi = {
  fetchActivitiesStats: async (filters: DashboardFilters): Promise<DashboardStatsResponse> => {
    try {
      const data = await getActivitiesStats(filters);
      return data;
    } catch (error: any) {
      console.error("Erro ao buscar estatísticas do dashboard:", error.message);
      throw error;
    }
  },
};

/**
 * Hook para buscar estatísticas de atividades
 * Cache de 1 minuto, mantém dados anteriores durante loading
 */
export const useDashboardStats = (
  filters: DashboardFilters
): UseQueryResult<DashboardStatsResponse, Error> => {
  return useQuery<DashboardStatsResponse, Error>(
    ['dashboardStats', filters],
    () => dashboardApi.fetchActivitiesStats(filters),
    {
      staleTime: 60000, // 1 minuto
      keepPreviousData: true,
      retry: 2,
      enabled: !!filters.startDate && !!filters.endDate,
    }
  );
};

